import { useEffect, useState } from "react";

let _open = null;

export function confirmDialog(opts = {}) {
  return new Promise((resolve) => { if (_open) _open({ type: "confirm", ...opts, resolve }); else resolve(false); });
}
export function promptDialog(opts = {}) {
  return new Promise((resolve) => { if (_open) _open({ type: "prompt", ...opts, resolve }); else resolve(null); });
}

export function ConfirmHost() {
  const [state, setState] = useState(null);
  const [val, setVal] = useState("");
  useEffect(() => { _open = (s) => { setVal(s.defaultValue || ""); setState(s); }; return () => { _open = null; }; }, []);
  if (!state) return null;
  const cancelResult = state.type === "confirm" ? false : null;
  const close = (result) => { state.resolve(result); setState(null); };
  return (
    <div className="fixed inset-0 z-[3000] flex items-center justify-center bg-black/50 p-4" onClick={() => close(cancelResult)} data-testid="app-dialog-overlay">
      <div onClick={(e) => e.stopPropagation()} className="w-full max-w-sm rounded-2xl bg-white p-5 shadow-2xl" data-testid="app-dialog">
        <div className="text-sm font-bold text-slate-900">{state.title || (state.type === "confirm" ? "Bevestigen" : "Invoer")}</div>
        {state.message && <p className="mt-2 text-sm text-slate-600">{state.message}</p>}
        {state.type === "prompt" && (
          <input data-testid="app-dialog-input" autoFocus value={val} onChange={(e) => setVal(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") close(val); }}
            className="mt-3 w-full rounded-xl border border-slate-200 px-3 py-2.5 text-sm outline-none focus:border-blue-500" />
        )}
        <div className="mt-4 flex justify-end gap-2">
          <button data-testid="app-dialog-cancel" onClick={() => close(cancelResult)} className="rounded-xl border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50">{state.cancelText || "Annuleren"}</button>
          <button data-testid="app-dialog-confirm" onClick={() => close(state.type === "confirm" ? true : val)} className={`rounded-xl px-4 py-2 text-sm font-semibold text-white ${state.danger ? "bg-red-600 hover:bg-red-500" : "bg-blue-600 hover:bg-blue-500"}`}>{state.confirmText || "OK"}</button>
        </div>
      </div>
    </div>
  );
}
